import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const checkAreThereAnyMeters = async () => {
	try {
		const { data } = await client.get(`/Meter/addresses`, {
			headers: authHeader(),
		});
		if (data.length > 0) {
			return true;
		} else return false;
	} catch (e) {
		console.log(e);
	}
};

export default checkAreThereAnyMeters;
